import'./CriaConta.css';
import { useNavigate, Link } from 'react-router-dom';
import {useState} from 'react';
import api from '../../services/api.js';

function CriaConta(){
    const [grava,setGrava] = useState(true);
    const [usuario,setUsuario] = useState('');
    const [nome,setNome] = useState('');
    const [email,setEmail] = useState('');
    const [senha1,setSenha1] = useState('');
    const [senha2,setSenha2] = useState('');
    const [mensagem,setMensagem] = useState('');


    const [campos, setCampos] = useState({
        IdCliente: 0,
        Nome:'',
        Email:'',
        Senha:''
    });
      const navigate = useNavigate();
 
      function MyChangeUsuario(event) { setUsuario(event.target.value); }

      function MyChangeNome(event) { setNome(event.target.value); }

      function MyChangeEmail(event) { setEmail(event.target.value); }
    
      function MyChangeSenha1(event) { setSenha1(event.target.value); }
      
      function MyChangeSenha2(event) { setSenha2(event.target.value); }
      
      function MyCus(){
        
        alert('submentendo campo ')
      } 

    async function CadastraConta(event)
      {
        if   (nome==="")  { alert('Favor informar o nome do usuário !') }
        else if   (usuario==="")  { alert('Favor informar o CPF ou CNPJ do cliente !') }
        else if   (email==="")  { alert('Favor informar o email do usuário !') }
        else if   (senha1==='')  { alert('Favor informar a primeira senha !') }
        else if   (senha2==='')  { alert('Favor informar a confirmação da senha !') }
        else if   (senha1 !== senha2)  { alert('Senhas divergentes, os campos senha devem ser exatamente iguais !')   }

        if  (! email.match('@')) {
            setMensagem('Favor informar um Email válido !');
            return;
        } 

        event.preventDefault();
        const response = await api.get('/cliente/login/verificausuario.php/?e='+usuario);
        const IdUsuario = response.data[0].IdUsuario;

        campos['IdCliente'] = IdUsuario;
        campos['Nome'] = nome;
        campos['Email'] = email;
        campos['Senha'] = senha1;

        if   (Number(IdUsuario) === 0) { 
            alert('Nenhum cliente encontrado com esse CNPJ/CPF !')
            setGrava(false) 
            return;
        }
        
        (async () => {
            const Registro = JSON.stringify(campos);
            console.log(Registro);
           
            await api.post('/cliente/login/inclui.php',  Registro )
              .then(res => {
              }).then(alert('Usuário cadastrado com sucesso !')).then( navigate('/'));
                 
            })();

      }

    return (
        <div className="row"> 
             <div className="col-sm-3 d-flex - justify-content-center align-items-center text-center">
                
                <form className="form-conta">

                    <h4 className='mb-5'>Cadastre sua conta</h4>    

                    <div className="form-floating">
                        <input type ="cnpj" className="form-control" id="FloatingInput"
                            placeholder='CNPJ/CPF' onChange={MyChangeUsuario} onBeforeInput={MyCus} />
                        <label htmlFor='FloatingInput'>CNPJ/CPF - Cliente Solaris </label>
                    </div>  
                    
                    <div className="form-floating">
                        <input type ="cnpj" className="form-control" id="Nome" name='Nome'
                            placeholder='Nome completo'  onChange={MyChangeNome} />
                        <label htmlFor='FloatingInput'>Nome Completo</label>
                    </div>

                    <div className="form-floating">
                        <input type="email" className="form-control" id="Email" name='Email'
                            placeholder='Email'  onChange={MyChangeEmail}  />
                        <label htmlFor='FloatingInput'>Email</label>
                    </div>

                    <div className="form-floating">
                        <input type = "password" className="form-control" id="Senha1" name='Senha1' 
                            placeholder='digite a senha'   onChange={MyChangeSenha1}/>
                        <label htmlFor='FloatingInput'>digite a senha</label>
                    </div>

                    <div className="form-floating">
                        <input type = "password" className="form-control" id="Senha2" name='Senha2'
                            placeholder='confirme a senha'  onChange={MyChangeSenha2} />
                        <label htmlFor='FloatingInput'>confirme a senha</label>
                    </div>


                    <button className="w-100   btn btn-primary"  type='button'  onClick={CadastraConta}>
                        <span className='ms-2'>Cadastrar</span>                  
                    </button>

                    {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}

                    <div className="login-links mt-5">
                        <Link to="/" className="mx-3">Voltar à tela anteior</Link>
                    </div>

                </form>

            </div>
        </div>
)

}

export default CriaConta;